/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/projects', children: 'projects' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/ProjectsLink.js